<section id="sidebar" class="sidebar">
    <div>
        <app-mng-menu-list></app-mng-menu-list>
    </div>
</section>

<!-- <section id="sidebar-dark" class="sidebar-dark active">
    <div>
        <ul class="list-group">
            <li class="list-group-item">
                <a class="heading">Store</a>
            </li>
            <li class="list-group-item">
                <a routerLink="/store/home" routerLinkActive="active">Overview</a>
            </li>
            <li class="list-group-item">
                <a routerLink="/store/user" routerLinkActive="active">Enabled Apps</a>
            </li>
            <li class="list-group-item">
                <a routerLink="/store/available" routerLinkActive="active">Available Apps</a>
            </li>
        </ul>
    </div>
</section> -->